import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedSites from './components/FeaturedSites';
import ArticleList from './components/ArticleList';
import { useSEO, injectJSONLD } from '@/hooks/useSEO';
import { useEffect } from 'react';

export default function Home() {
  useSEO({
    title: '蓝导航——精选网址导航一站直达',
    description: '蓝导航是一款专业的网址导航平台，汇聚海量优质网站资源，分类清晰、访问便捷。无论您需要查找工具、资讯、娱乐还是购物网站，蓝导航都能帮您快速定位，节省上网时间，提升浏览效率。',
    keywords: '蓝导航,蓝导航网址大全,蓝导航入口,蓝导航官网,网址导航推荐,精选网站导航,上网导航首页',
    canonicalUrl: 'https://www.lan-dao.com/',
  });

  useEffect(() => {
    injectJSONLD({
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '蓝导航',
      url: 'https://www.lan-dao.com/',
      description: '蓝导航是一款专业的网址导航平台，汇聚海量优质网站资源，分类清晰、访问便捷。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.lan-dao.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
      publisher: {
        '@type': 'Organization',
        name: '蓝导航',
        url: 'https://www.lan-dao.com/',
      },
    });

    injectJSONLD({
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '蓝导航',
      url: 'https://www.lan-dao.com/',
      description: '蓝导航是一款专业的网址导航平台，汇聚海量优质网站资源。',
      address: {
        '@type': 'PostalAddress',
        addressLocality: '北京市',
        addressRegion: '北京',
        addressCountry: 'CN',
      },
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '400-888-0000',
        contactType: 'customer service',
        email: 'contact@lan-dao.com',
      },
    });
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedSites />
        <ArticleList />

        <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="bg-accent-100/50 rounded-3xl p-8 md:p-12 text-center border border-accent-200/50">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              还没有找到想要的网站？
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto mb-6">
              欢迎向我们推荐优质网站资源，审核通过后将收录至蓝导航，帮助更多人发现好网站
            </p>
            <a
              href="/about"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors duration-200"
            >
              <i className="ri-add-line"></i>
              提交网站
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}